/* global axios */
import ApiClient from './ApiClient';

class AiBotAPI extends ApiClient {
  constructor() {
    super('ai_bot/assistants', { accountScoped: true });
  }

  assistants() {
    return axios.get(this.url);
  }

  limits() {
    return axios.get(this.url.replace('ai_bot/assistants', 'ai_bot/limits'));
  }

  createAssistant(data) {
    return axios.post(this.url, data);
  }

  updateAssistant(id, data) {
    return axios.patch(`${this.url}/${id}`, data);
  }

  deleteAssistant(id) {
    return axios.delete(`${this.url}/${id}`);
  }

  knowledgeEntries(assistantId, params = {}) {
    return axios.get(`${this.url}/${assistantId}/knowledge_entries`, {
      params,
    });
  }

  createKnowledgeEntry(assistantId, data) {
    return axios.post(`${this.url}/${assistantId}/knowledge_entries`, data);
  }

  updateKnowledgeEntry(assistantId, entryId, data) {
    return axios.patch(
      `${this.url}/${assistantId}/knowledge_entries/${entryId}`,
      data
    );
  }

  deleteKnowledgeEntry(assistantId, entryId) {
    return axios.delete(`${this.url}/${assistantId}/knowledge_entries/${entryId}`);
  }

  approveKnowledgeEntry(assistantId, entryId) {
    return axios.post(
      `${this.url}/${assistantId}/knowledge_entries/${entryId}/approve`
    );
  }

  rejectKnowledgeEntry(assistantId, entryId) {
    return axios.post(
      `${this.url}/${assistantId}/knowledge_entries/${entryId}/reject`
    );
  }

  documents(assistantId, params = {}) {
    return axios.get(`${this.url}/${assistantId}/documents`, { params });
  }

  createDocument(assistantId, data) {
    return axios.post(`${this.url}/${assistantId}/documents`, data);
  }

  updateDocument(assistantId, documentId, data) {
    return axios.patch(`${this.url}/${assistantId}/documents/${documentId}`, data);
  }

  processDocument(assistantId, documentId) {
    return axios.post(
      `${this.url}/${assistantId}/documents/${documentId}/process_document`
    );
  }

  deleteDocument(assistantId, documentId) {
    return axios.delete(`${this.url}/${assistantId}/documents/${documentId}`);
  }

  inboxLinks(assistantId) {
    return axios.get(`${this.url}/${assistantId}/inbox_links`);
  }

  createInboxLink(assistantId, data) {
    return axios.post(`${this.url}/${assistantId}/inbox_links`, data);
  }

  updateInboxLink(assistantId, linkId, data) {
    return axios.patch(`${this.url}/${assistantId}/inbox_links/${linkId}`, data);
  }

  deleteInboxLink(assistantId, linkId) {
    return axios.delete(`${this.url}/${assistantId}/inbox_links/${linkId}`);
  }

  customTools(assistantId, params = {}) {
    return axios.get(`${this.url}/${assistantId}/custom_tools`, { params });
  }

  createCustomTool(assistantId, data) {
    return axios.post(`${this.url}/${assistantId}/custom_tools`, data);
  }

  updateCustomTool(assistantId, toolId, data) {
    return axios.patch(`${this.url}/${assistantId}/custom_tools/${toolId}`, data);
  }

  deleteCustomTool(assistantId, toolId) {
    return axios.delete(`${this.url}/${assistantId}/custom_tools/${toolId}`);
  }

  usage(params = {}) {
    return axios.get(
      this.url.replace('ai_bot/assistants', 'ai_bot/usage'),
      { params }
    );
  }

  reports(params = {}) {
    return axios.get(
      this.url.replace('ai_bot/assistants', 'ai_bot/reports'),
      { params }
    );
  }

  creditManagement(params = {}) {
    return axios.get(
      this.url.replace('ai_bot/assistants', 'ai_bot/credit_management'),
      { params }
    );
  }

  creditCheckout(amountCents) {
    return axios.post(
      this.url.replace('ai_bot/assistants', 'ai_bot/credit_checkout'),
      { amount_cents: amountCents }
    );
  }

}

export default new AiBotAPI();
